(() => {
  if (!customElements.get('coverly-cart-responsive-save')) {
    class CoverlyCartResponsiveSave extends HTMLElement {
      connectedCallback() {
        this.labels = new WeakMap();
        this.mobile = matchMedia('(max-width: 749px)');
        this.updateLabels = () => {
          this.querySelectorAll('.coverly-cart-btns__btn').forEach(button => {
            // Leave PPO's pending state and click handler intact.
            if (button.disabled) return;
            if (!this.labels.has(button)) this.labels.set(button, button.textContent);
            const label = this.mobile.matches ? this.dataset.mobileLabel : this.labels.get(button);
            if (label && button.textContent !== label) button.textContent = label;
          });
        };
        this.observer = new MutationObserver(this.updateLabels);
        this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        this.mobile.addEventListener('change', this.updateLabels);
        this.updateLabels();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.updateLabels);
      }
    }
    customElements.define('coverly-cart-responsive-save', CoverlyCartResponsiveSave);
  }

  if (!customElements.get('coverly-cart-line-actions')) {
    class CoverlyCartLineActions extends HTMLElement {
      connectedCallback() {
        const item = this.closest('.cart-item');
        if (!item) return;
        const place = () => {
          item.querySelectorAll('.coverly-cart-actions').forEach(actions => {
            // Preserve PPO's actual buttons and their event handlers.
            if (actions.parentElement !== this) this.append(actions);
          });
        };
        this.observer = new MutationObserver(place);
        this.observer.observe(item, { childList: true, subtree: true });
        place();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    }
    customElements.define('coverly-cart-line-actions', CoverlyCartLineActions);
  }

  if (!customElements.get('coverly-cart-payments')) {
    class CoverlyCartPayments extends HTMLElement {
      connectedCallback() {
        this.resizeObserver = new ResizeObserver(() => this.updateFit());
        this.resizeObserver.observe(this);
        this.updateFit();
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
      updateFit() {
        const list = this.querySelector('.coverly-cart-payment-list');
        const shopPay = this.querySelector('[data-coverly-shop-pay]');
        if (!list || !shopPay || list.clientWidth <= 0) return;
        const items = [...list.children];
        const width = parseFloat(getComputedStyle(shopPay).width);
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        // Include Shop Pay's fixed width even while hidden so resizing can restore it.
        const requiredWidth = items.length * width + Math.max(0, items.length - 1) * gap;
        shopPay.hidden = requiredWidth > list.clientWidth + 0.5;
      }
    }
    customElements.define('coverly-cart-payments', CoverlyCartPayments);
  }
})();
